import React, { useMemo } from "react";
import { Configure, useHits } from "react-instantsearch";
import {
  RelatedContentHitsProps,
  StoryHit,
} from "../../lib/storyblok/types/blocks/RelatedContentBlock";
import RelatedContentUi from "../../ui/RelatedContent";
import {
  processContentTypes,
  buildFilterQuery,
} from "../../lib/utils/relatedContentUtils";

const RelatedContentHits: React.FC<RelatedContentHitsProps> = ({
  title,
  description,
  style,
  innerSpacing,
  outerSpacing,
  buttons,
  contentType,
  products,
  solutions,
  storiesCount,
  inverted,
  contentLayout,
}) => {
  const { hits } = useHits<StoryHit>();

  const storyTypes = useMemo(
    () => processContentTypes(contentType),
    [contentType]
  );

  const filterQuery = useMemo(
    () => buildFilterQuery(storyTypes, products, solutions),
    [storyTypes, products, solutions]
  );

  return (
    <>
      <Configure
        filters={filterQuery}
        hitsPerPage={storiesCount.value}
        distinct
      />
      <RelatedContentUi
        stories={hits}
        title={title}
        description={description}
        style={style}
        inverted={inverted}
        innerSpacing={innerSpacing}
        outerSpacing={outerSpacing}
        buttons={buttons}
        contentLayout={contentLayout}
      />
    </>
  );
};

export default RelatedContentHits;
